import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Input,
  Slide,
  Button,
  IconButton,
  InputAdornment,
  ClickAwayListener,
  Tooltip,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { bgBlur } from '../../../utils/cssStyles';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';
import actions from 'src/store/actions';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const StyledSearchbar = styled('div')(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: HEADER_MOBILE,
  padding: theme.spacing(0, 3),
  boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

export default function Searchbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [criteria, setCriteria] = React.useState('');
  const dispatch = useDispatch();
  const path = window.location.pathname;

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = () => {
    switch (String(window.location.pathname)) {
      case '/customers':
        dispatch(actions.CUSTOMERS.getAllCustomers({ criteria, searchValue }));
        break;
      case '/rmas': {
        if (criteria === 'serial' || criteria === 'newSerial') {
          dispatch(actions.RMA.getFilteredArticle({ criteria, searchValue }));
        } else if (criteria === 'trackingNr') {
          dispatch(actions.RMA.getRmaTracking(searchValue));
        } else {
          dispatch(actions.RMA.getAllRmas({ criteria, searchValue }));
        }
        break;
      }
      case '/warehouse': {
        dispatch(actions.RMA.getAllRmas(searchValue));
        break;
      }
      default:
        break;
    }
  };

  const clearSearch = () => {
    switch (String(window.location.pathname)) {
      case '/customers': {
        setSearchValue('');
        dispatch(actions.CUSTOMERS.getAllCustomers());
        break;
      }
      case '/rmas': {
        setSearchValue('');
        dispatch(actions.RMA.getAllRmas());
        break;
      }
      default:
        break;
    }
  };

  return null;
}
